import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const EditPermissionSetWrapper = lazy(() =>
  import("@scenes/PermissionSettings/components/EditPermissionSet/EditPermissionSetWrapper").then((module) => ({
    default: module.EditPermissionSetWrapper,
  }))
);

export const savedPermissionSettingsPermissionSetNRO: NavigationRoutingObject = {
  Component: EditPermissionSetWrapper,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("edit-permission-set-nro-heading", "Edit Permission Set"),
  pageNameForTracking: () => "Edit Permission Set",
  getDeveloperNavigationAllowed: ({ hasPermission }) => {
    return hasPermission("company", {
      permission: "manageCompanySettings",
    });
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/company_settings/user_management/permission_sets/:appGroupId",
};
